// Données des villes du Loiret ciblées en SEO local.
// Chaque ville a son contenu UNIQUE pour éviter le duplicate content (cf. règles Google "doorway pages").
// Le maillage interne se fait automatiquement via le tableau `neighbors`.

const CITIES = [
    {
        slug: "olivet",
        name: "Olivet",
        postal: "45160",
        population: "22 000",
        distance: 5,
        lat: 47.8625,
        lon: 1.9009,
        introHook:
            "Commune limitrophe sud d'Orléans, traversée par le Loiret, Olivet est appréciée pour ses quartiers résidentiels (Larry, Béard, Hospitalet) et ses bords de rivière. Notre serrurier intervient en moins de 20 minutes depuis Orléans, y compris dans les rues calmes des berges et les zones pavillonnaires.",
        districts: ["Centre-bourg", "Larry", "Béard", "Hospitalet", "Le Poutyl", "Avenue du Loiret"],
        reviews: [
            { n: "Christophe L.", q: "Olivet centre", t: "Porte claquée un samedi soir avenue du Loiret. Intervention en 15 minutes, ouverture sans casse. Très pro et tarif respecté." },
            { n: "Marie-Anne T.", q: "Olivet Larry", t: "Pose d'une serrure A2P 3 étoiles après cambriolage. Conseils précieux et travail soigné. Je recommande chaudement." },
            { n: "Bernard H.", q: "Olivet Béard", t: "Clé cassée dans le barillet de mon portail. Réparation impeccable, l'artisan a même graissé tout le mécanisme. Au top." },
        ],
        neighbors: ["orleans", "saint-pryve-saint-mesmin", "saint-jean-de-la-ruelle", "saint-cyr-en-val"],
    },
    {
        slug: "fleury-les-aubrais",
        name: "Fleury-les-Aubrais",
        postal: "45400",
        population: "21 000",
        distance: 4,
        lat: 47.9269,
        lon: 1.9176,
        introHook:
            "Voisine directe d'Orléans au nord, Fleury-les-Aubrais est connue pour sa gare TGV et ses quartiers Lignerolles, Cabanes et Bois Pasquier. Que vous habitiez en pavillon ou en résidence, notre artisan serrurier intervient rapidement, même la nuit et le week-end.",
        districts: ["Centre-ville", "Lignerolles", "Cabanes", "Bois Pasquier", "Quartier de la Gare", "Les Aubrais"],
        reviews: [
            { n: "Patricia D.", q: "Fleury centre", t: "Verrou bloqué un dimanche matin. Diagnostic au téléphone clair, intervention dans la demi-heure, remplacement immédiat. Parfait." },
            { n: "Olivier M.", q: "Fleury Lignerolles", t: "Pose d'une porte blindée BP2 en RDC. Finitions impeccables, pas de dégât du chambranle. Travail d'artisan sérieux." },
            { n: "Sylvie P.", q: "Fleury Bois Pasquier", t: "Effraction sur la porte d'entrée. Mise en sécurité dans l'heure, justificatifs assurance fournis. Très réactif." },
        ],
        neighbors: ["orleans", "saran", "saint-jean-de-braye", "chevilly"],
    },
    {
        slug: "saran",
        name: "Saran",
        postal: "45770",
        population: "16 000",
        distance: 7,
        lat: 47.9514,
        lon: 1.8794,
        introHook:
            "Située au nord d'Orléans, Saran est un pôle commercial majeur (zone Cap Saran) entouré de quartiers pavillonnaires familiaux. Nos interventions couvrent aussi bien le centre que les lotissements de Chèvre Blanche ou des Aydes.",
        districts: ["Centre-bourg", "Chèvre Blanche", "Les Aydes", "Le Chêne Maillard", "Zone Cap Saran"],
        reviews: [
            { n: "Jean-Claude V.", q: "Saran centre", t: "Cylindre HS après tentative d'effraction. Diagnostic honnête, remplacement par un cylindre haute sécurité. Bon prix." },
            { n: "Sophie L.", q: "Saran Chèvre Blanche", t: "Porte d'entrée qui refusait de fermer. Réglage et remplacement de la gâche en 30 minutes. Très pédagogue." },
            { n: "Marc B.", q: "Saran Les Aydes", t: "Perte de clés, changement de serrure complet sur ma porte palière. Tarif annoncé respecté, facture détaillée. Top." },
        ],
        neighbors: ["orleans", "fleury-les-aubrais", "ormes", "ingre"],
    },
    {
        slug: "saint-jean-de-braye",
        name: "Saint-Jean-de-Braye",
        postal: "45800",
        population: "21 000",
        distance: 5,
        lat: 47.9114,
        lon: 1.9678,
        introHook:
            "Située à l'est d'Orléans en bord de Loire, Saint-Jean-de-Braye conjugue centre-ville historique (église Saint-Jean) et quartiers pavillonnaires (Vallée, Pont-Bordeau). Notre serrurier intervient rapidement dans tout le secteur, y compris pour les portes anciennes des maisons en pierre.",
        districts: ["Centre", "Vallée", "Pont-Bordeau", "Les Châtaigniers", "Frédeville", "Charbonnière"],
        reviews: [
            { n: "Hélène G.", q: "Saint-Jean-de-Braye centre", t: "Vieille serrure à mortaiser bloquée. L'artisan a su trouver le mécanisme adapté pour une porte de 1920. Excellent." },
            { n: "Thierry R.", q: "Saint-Jean-de-Braye Vallée", t: "Remplacement complet de la serrure multipoints. Pose nette et fonctionnelle, conseils pour l'entretien." },
            { n: "Aïcha M.", q: "Saint-Jean-de-Braye Frédeville", t: "Ouverture de porte claquée à 23h. Arrivée en 20 minutes, ouverture sans aucun dégât. Sauvée !" },
        ],
        neighbors: ["orleans", "fleury-les-aubrais", "checy", "combleux"],
    },
    {
        slug: "saint-jean-de-la-ruelle",
        name: "Saint-Jean-de-la-Ruelle",
        postal: "45140",
        population: "17 000",
        distance: 4,
        lat: 47.9078,
        lon: 1.8678,
        introHook:
            "Commune dense située à l'ouest d'Orléans, Saint-Jean-de-la-Ruelle (souvent surnommée « Saint-Jean ») accueille de nombreux immeubles collectifs (quartier des Genêts, Croix Saint-Marceau) ainsi que des maisons individuelles. Notre artisan intervient aussi bien sur portes palières que portes d'immeuble.",
        districts: ["Centre", "Les Genêts", "Croix Saint-Marceau", "Faubourg Bannier", "Plaisance"],
        reviews: [
            { n: "Frédéric A.", q: "Saint-Jean-de-la-Ruelle Genêts", t: "Porte d'appartement claquée, intervention rapide par crochetage. Aucune trace, le syndic n'y a vu que du feu." },
            { n: "Nathalie K.", q: "Saint-Jean-de-la-Ruelle centre", t: "Serrure de boîte aux lettres et porte palière changées en une seule visite. Très efficace, tarif raisonnable." },
            { n: "Lucas D.", q: "Saint-Jean-de-la-Ruelle Plaisance", t: "Bloc-porte blindé posé dans la journée. Travail méticuleux et hyper bien expliqué." },
        ],
        neighbors: ["orleans", "ingre", "ormes", "la-chapelle-saint-mesmin"],
    },
    {
        slug: "montargis",
        name: "Montargis",
        postal: "45200",
        population: "14 000",
        distance: 70,
        lat: 47.9986,
        lon: 2.7339,
        introHook:
            "Surnommée la « Venise du Gâtinais » pour ses canaux et son centre historique, Montargis combine vieilles bâtisses (rue Dorée, place du Pâtis) et résidences modernes. Notre artisan se déplace dans tout le bassin montargois, y compris les communes alentour (Amilly, Châlette, Villemandeur).",
        districts: ["Centre historique", "Rue Dorée", "Place du Pâtis", "Le Pâtis", "Quartier de la Gare", "La Chaussée"],
        reviews: [
            { n: "Bernadette R.", q: "Montargis centre historique", t: "Porte en chêne ancienne bloquée. L'artisan a su préserver le caractère d'origine tout en sécurisant. Bravo." },
            { n: "Pascal C.", q: "Montargis Le Pâtis", t: "Effraction sur volet et porte. Mise en sécurité immédiate, remplacement le lendemain. Très humain dans l'épreuve." },
            { n: "Karine S.", q: "Montargis La Chaussée", t: "Pose de serrure A2P trois étoiles sur conseil d'assurance. Travail soigné, garantie de 2 ans. Confiance totale." },
        ],
        neighbors: ["amilly", "chalette-sur-loing", "villemandeur", "courtenay"],
    },
    {
        slug: "pithiviers",
        name: "Pithiviers",
        postal: "45300",
        population: "9 000",
        distance: 45,
        lat: 48.1719,
        lon: 2.2533,
        introHook:
            "Sous-préfecture du Loiret située au nord du département, Pithiviers est célèbre pour son gâteau et son centre historique autour de l'église Saint-Salomon-et-Saint-Grégoire. Notre serrurier dépanne aussi à Pithiviers-le-Vieil et dans les communes proches (Dadonville, Yèvre-le-Châtel).",
        districts: ["Centre", "Faubourg d'Orléans", "Sainte-Croix", "Saint-Aignan", "Quartier de la Gare"],
        reviews: [
            { n: "Christine F.", q: "Pithiviers centre", t: "Mécanisme grippé d'une vieille porte d'entrée. Démontage, nettoyage, lubrification. Comme neuf et pas cher." },
            { n: "Romain T.", q: "Pithiviers Sainte-Croix", t: "Pose de porte blindée pour un commerce. Réactivité au top, finitions parfaites. Je recommande." },
            { n: "Évelyne D.", q: "Pithiviers Faubourg d'Orléans", t: "Clé cassée à l'intérieur du cylindre. Extraction propre sans casser la porte. Excellent service." },
        ],
        neighbors: ["malesherbes", "outarville", "dadonville", "puiseaux"],
    },
    {
        slug: "gien",
        name: "Gien",
        postal: "45500",
        population: "14 000",
        distance: 70,
        lat: 47.6878,
        lon: 2.6306,
        introHook:
            "Située au bord de la Loire avec son château et sa manufacture de faïence, Gien combine quartiers historiques et zones pavillonnaires modernes. Notre artisan serrurier intervient aussi sur les communes de Poilly-lez-Gien, Briare et Châtillon-sur-Loire.",
        districts: ["Centre historique", "Quartier du Château", "Faubourg Berry", "Cuiry", "Le Berry"],
        reviews: [
            { n: "Michèle B.", q: "Gien centre", t: "Serrure de portail rouillée bloquée. Démontage, nettoyage, lubrification. Tout refonctionne parfaitement." },
            { n: "Antoine V.", q: "Gien Faubourg Berry", t: "Pose d'une serrure haute sécurité sur recommandation d'assurance. Tarif honnête, pose impeccable." },
            { n: "Sandra L.", q: "Gien Cuiry", t: "Porte palière qui ne fermait plus suite à un affaissement. Réglage complet, plus aucun jeu. Super." },
        ],
        neighbors: ["briare", "chatillon-sur-loire", "poilly-lez-gien", "sully-sur-loire"],
    },
    {
        slug: "chateauneuf-sur-loire",
        name: "Châteauneuf-sur-Loire",
        postal: "45110",
        population: "8 000",
        distance: 25,
        lat: 47.8636,
        lon: 2.2253,
        introHook:
            "Charmante commune ligérienne réputée pour son parc et son église Saint-Martial, Châteauneuf-sur-Loire est entourée de villages pittoresques (Saint-Denis-de-l'Hôtel, Sigloy, Germigny-des-Prés). Notre serrurier intervient sur tout ce secteur en moins de 35 minutes depuis Orléans.",
        districts: ["Centre", "Quartier du Parc", "Bonnée", "Les Hauts"],
        reviews: [
            { n: "Vincent G.", q: "Châteauneuf-sur-Loire centre", t: "Cylindre de porte de garage cassé. Remplacement en 20 minutes avec une marque haut de gamme. Parfait." },
            { n: "Marina P.", q: "Châteauneuf-sur-Loire Bonnée", t: "Ouverture de porte un dimanche après-midi. Intervention rapide, aucun dégât, et tarif honnête." },
            { n: "Henri J.", q: "Châteauneuf-sur-Loire centre", t: "Serrure 3 points remplacée sur conseil après un dégât des eaux. Travail propre et garantie incluse." },
        ],
        neighbors: ["jargeau", "sully-sur-loire", "saint-denis-de-lhotel", "germigny-des-pres"],
    },
    {
        slug: "beaugency",
        name: "Beaugency",
        postal: "45190",
        population: "7 000",
        distance: 25,
        lat: 47.7775,
        lon: 1.6325,
        introHook:
            "Cité médiévale classée au patrimoine mondial de l'UNESCO (Val de Loire), Beaugency séduit par sa Tour César et son pont sur la Loire. Notre serrurier respecte le bâti ancien et intervient avec précaution sur les portes de caractère, tout en sécurisant les habitations modernes du quartier des Garennes.",
        districts: ["Centre médiéval", "Tour César", "Les Garennes", "Quartier du Petit Bois", "Les Hauts de Beaugency"],
        reviews: [
            { n: "Caroline R.", q: "Beaugency centre médiéval", t: "Vieille serrure de 1900 grippée. L'artisan a su trouver les bonnes pièces pour préserver l'authenticité." },
            { n: "François O.", q: "Beaugency Les Garennes", t: "Remplacement complet après cambriolage. Mise en sécurité immédiate, justificatifs assurance complets." },
            { n: "Émilie D.", q: "Beaugency centre", t: "Pose d'un cylindre A2P 2 étoiles sur porte d'entrée. Tarif annoncé respecté, pas de mauvaise surprise." },
        ],
        neighbors: ["meung-sur-loire", "tavers", "lailly-en-val", "cravant"],
    },
    {
        slug: "amilly",
        name: "Amilly",
        postal: "45200",
        population: "12 000",
        distance: 68,
        lat: 47.9611,
        lon: 2.7514,
        introHook:
            "Voisine directe de Montargis, Amilly est une commune dynamique du Gâtinais, à la fois résidentielle et industrielle avec la zone d'activités des Terres Blanches. Notre artisan y intervient rapidement pour toute urgence de serrurerie, dans les quartiers pavillonnaires comme dans les zones tertiaires.",
        districts: ["Centre-ville", "Les Terres Blanches", "Le Puiseaux", "La Pierre", "Viroy"],
        reviews: [
            { n: "Jean-François M.", q: "Amilly centre", t: "Ouverture de porte en 25 minutes un mardi soir. Aucune casse, tarif clair. Artisan professionnel." },
            { n: "Sonia B.", q: "Amilly Les Terres Blanches", t: "Pose d'une serrure multipoints après achat de la maison. Travail soigné, garantie de 2 ans incluse." },
            { n: "Alain P.", q: "Amilly Viroy", t: "Clé cassée un dimanche matin. Intervention rapide et propre, plus aucun souci depuis." },
        ],
        neighbors: ["montargis", "chalette-sur-loing", "villemandeur", "saint-maurice-sur-fessard"],
    },
    {
        slug: "chalette-sur-loing",
        name: "Châlette-sur-Loing",
        postal: "45120",
        population: "12 500",
        distance: 68,
        lat: 47.9925,
        lon: 2.7269,
        introHook:
            "Traversée par le Loing et le canal de Briare, Châlette-sur-Loing forme avec Montargis et Amilly l'agglomération montargoise. Habitat mixte (grands ensembles du Château-Blanc, pavillons de Vésines), notre serrurier intervient dans tout le secteur en moins de 40 minutes.",
        districts: ["Centre", "Château-Blanc", "Vésines", "Kennedy", "Lancy"],
        reviews: [
            { n: "Nadia S.", q: "Châlette Château-Blanc", t: "Porte palière bloquée un matin de novembre. Réglage et remplacement de la gâche, plus aucun problème." },
            { n: "Cédric L.", q: "Châlette Vésines", t: "Pose d'une porte blindée sur pavillon. Travail impeccable, aucun dégât sur le chambranle." },
            { n: "Josiane B.", q: "Châlette centre", t: "Serrure changée après perte de trousseau. Rapide, honnête, garantie fournie." },
        ],
        neighbors: ["montargis", "amilly", "villemandeur", "corquilleroy"],
    },
    {
        slug: "la-chapelle-saint-mesmin",
        name: "La Chapelle-Saint-Mesmin",
        postal: "45380",
        population: "10 000",
        distance: 7,
        lat: 47.8908,
        lon: 1.8339,
        introHook:
            "Commune de la métropole orléanaise en bord de Loire, La Chapelle-Saint-Mesmin conjugue coteaux résidentiels, zones d'activités (Coquilles) et petites rues du centre autour de l'église Saint-Mesmin. Notre serrurier y intervient en une vingtaine de minutes maximum.",
        districts: ["Centre", "Les Coquilles", "Bel Air", "Les Peupliers", "Val d'Ardoux"],
        reviews: [
            { n: "Bruno L.", q: "La Chapelle centre", t: "Cylindre remplacé rapidement après perte de clés. Sérieux et efficace, prix cohérent." },
            { n: "Isabelle V.", q: "La Chapelle Bel Air", t: "Serrure grippée sur porte de garage. Démontée, nettoyée, remise en état. Économique." },
            { n: "Manuel D.", q: "La Chapelle Val d'Ardoux", t: "Ouverture de porte claquée en 20 min. Merci pour l'intervention rapide un vendredi soir." },
        ],
        neighbors: ["orleans", "saint-jean-de-la-ruelle", "ingre", "saint-ay"],
    },
    {
        slug: "ingre",
        name: "Ingré",
        postal: "45140",
        population: "8 500",
        distance: 8,
        lat: 47.9203,
        lon: 1.8397,
        introHook:
            "Commune résidentielle limitrophe d'Orléans à l'ouest, Ingré s'est développée autour de son bourg ancien et de nouveaux quartiers pavillonnaires (Bel Air, Sente aux Loups). Nos interventions rapides couvrent aussi le pôle scolaire et les zones commerciales des Bruères.",
        districts: ["Centre-bourg", "Bel Air", "Sente aux Loups", "Les Bruères", "Le Bardon"],
        reviews: [
            { n: "Franck D.", q: "Ingré centre", t: "Poignée arrachée après tentative d'effraction. Réparation et renforcement en une visite. Merci." },
            { n: "Marie-Ange R.", q: "Ingré Bel Air", t: "Serrure changée sur porte d'entrée. Marque conseillée était la bonne, très content." },
            { n: "Xavier T.", q: "Ingré Sente aux Loups", t: "Devis clair, pose rapide, travail propre. Rien à redire." },
        ],
        neighbors: ["orleans", "saint-jean-de-la-ruelle", "ormes", "la-chapelle-saint-mesmin"],
    },
    {
        slug: "checy",
        name: "Chécy",
        postal: "45430",
        population: "8 000",
        distance: 10,
        lat: 47.9083,
        lon: 2.0161,
        introHook:
            "Située à l'est d'Orléans en bord de Loire, Chécy est réputée pour son port de plaisance, ses vignes (AOC Orléans) et son marché dominical. L'habitat mêle centre historique et lotissements modernes ; notre artisan intervient dans toute la commune.",
        districts: ["Centre historique", "Port de plaisance", "Le Villiers", "Le Cens", "Les Vignes"],
        reviews: [
            { n: "Régis F.", q: "Chécy centre historique", t: "Porte ancienne à mortaiser réparée avec soin. L'artisan connaît son métier." },
            { n: "Aurélie N.", q: "Chécy Le Villiers", t: "Serrure de porte-fenêtre bloquée. Démontée et remise en marche, très rapide." },
            { n: "Hervé C.", q: "Chécy Les Vignes", t: "Pose porte blindée. Excellente exécution, garantie 2 ans en prime." },
        ],
        neighbors: ["orleans", "saint-jean-de-braye", "mardie", "combleux"],
    },
    {
        slug: "la-ferte-saint-aubin",
        name: "La Ferté-Saint-Aubin",
        postal: "45240",
        population: "7 500",
        distance: 25,
        lat: 47.7169,
        lon: 1.9403,
        introHook:
            "Située au cœur de la Sologne, La Ferté-Saint-Aubin abrite un splendide château et un centre bourg animé, entouré de résidences secondaires et de lotissements pavillonnaires. Notre serrurier intervient sur tout le territoire, y compris les résidences forestières isolées.",
        districts: ["Centre-bourg", "Château", "Les Rousselets", "Les Vinceux", "Les Peupliers"],
        reviews: [
            { n: "Sylvain M.", q: "La Ferté centre", t: "Ouverture rapide un dimanche. Merci d'être venu depuis Orléans si vite." },
            { n: "Corinne D.", q: "La Ferté Les Rousselets", t: "Serrure remplacée après perte de clés en promenade. Rassurant et pro." },
            { n: "Damien L.", q: "La Ferté centre", t: "Résidence secondaire équipée d'une porte blindée BP2. Nickel." },
        ],
        neighbors: ["olivet", "saint-cyr-en-val", "menestreau-en-villette", "marcilly-en-villette"],
    },
    {
        slug: "sully-sur-loire",
        name: "Sully-sur-Loire",
        postal: "45600",
        population: "5 500",
        distance: 45,
        lat: 47.7681,
        lon: 2.3781,
        introHook:
            "Ville du patrimoine ligérien dominée par son château (XIVe siècle), Sully-sur-Loire attire par ses ruelles anciennes, ses maisons à colombages et ses berges. Notre artisan y intervient avec le respect du bâti ancien, sans négliger les zones résidentielles récentes.",
        districts: ["Centre historique", "Château", "Les Champs Blancs", "Saint-Germain", "Saint-Ythier"],
        reviews: [
            { n: "Alain J.", q: "Sully centre", t: "Porte médiévale avec mécanisme spécial. Ouverte sans dégât, chapeau bas." },
            { n: "Christine T.", q: "Sully Saint-Ythier", t: "Serrure de portail changée. Choix judicieux du modèle, très content." },
            { n: "Éric V.", q: "Sully Les Champs Blancs", t: "Dépannage rapide un dimanche soir. Coût raisonnable pour une urgence." },
        ],
        neighbors: ["gien", "chateauneuf-sur-loire", "saint-benoit-sur-loire", "dampierre-en-burly"],
    },
    {
        slug: "meung-sur-loire",
        name: "Meung-sur-Loire",
        postal: "45130",
        population: "6 500",
        distance: 20,
        lat: 47.8306,
        lon: 1.7011,
        introHook:
            "Ville d'art et d'histoire évoquée par François Villon, Meung-sur-Loire séduit par ses ponts, ses moulins et son château. Habitats variés du bourg médiéval aux quartiers récents ; nous intervenons rapidement dans tout le canton.",
        districts: ["Centre historique", "Château", "Les Mauves", "La Nivelle", "Les Rochottes"],
        reviews: [
            { n: "Émilien F.", q: "Meung centre", t: "Ouverture non destructive d'une porte en chêne. Bien joué." },
            { n: "Nicole R.", q: "Meung Les Mauves", t: "Cylindre A2P posé. Bonne pédagogie sur les gammes existantes." },
            { n: "Grégoire B.", q: "Meung Les Rochottes", t: "Serrurier honnête et rapide. Devis respecté à l'euro près." },
        ],
        neighbors: ["beaugency", "clery-saint-andre", "baccon", "lailly-en-val"],
    },
    {
        slug: "briare",
        name: "Briare",
        postal: "45250",
        population: "5 500",
        distance: 80,
        lat: 47.6394,
        lon: 2.7375,
        introHook:
            "Ville pittoresque au confluent du canal de Briare et de la Loire, Briare est célèbre pour son pont-canal Eiffel. Notre artisan intervient dans ce joli secteur touristique, du centre historique aux résidences en bord de canal.",
        districts: ["Centre", "Le Pont-Canal", "Les Écluses", "La Chaussée", "Le Château"],
        reviews: [
            { n: "Yves M.", q: "Briare centre", t: "Serrure changée sur maison de bord de canal. Travail rapide et propre." },
            { n: "Christiane B.", q: "Briare Le Château", t: "Dépannage un dimanche pluvieux. Merci de vous être déplacés depuis Orléans." },
            { n: "Léon G.", q: "Briare La Chaussée", t: "Porte blindée pour résidence secondaire. Impeccable." },
        ],
        neighbors: ["gien", "chatillon-sur-loire", "ousson-sur-loire", "bonny-sur-loire"],
    },
    {
        slug: "chatillon-sur-loire",
        name: "Châtillon-sur-Loire",
        postal: "45360",
        population: "3 200",
        distance: 85,
        lat: 47.5828,
        lon: 2.7550,
        introHook:
            "Petit village fleuri sur les bords de Loire, Châtillon-sur-Loire séduit par ses maisons anciennes et sa quiétude. Notre serrurier accepte les déplacements dans ce secteur rural — appel préalable pour organiser au mieux l'intervention.",
        districts: ["Centre-bourg", "Le Coudroy", "Les Communes", "La Poissonnière"],
        reviews: [
            { n: "Michel R.", q: "Châtillon centre", t: "Pose de porte blindée sur maison ancienne. Travail respectueux du bâti." },
            { n: "Andrée C.", q: "Châtillon Les Communes", t: "Serrurier honnête, tarif clair pour un secteur rural." },
            { n: "Patrick D.", q: "Châtillon-sur-Loire", t: "Cylindre changé après perte de clés lors d'une randonnée. Merci." },
        ],
        neighbors: ["briare", "gien", "ouzouer-sur-trezee", "beaulieu-sur-loire"],
    },
    {
        slug: "saint-denis-en-val",
        name: "Saint-Denis-en-Val",
        postal: "45560",
        population: "7 500",
        distance: 6,
        lat: 47.8639,
        lon: 1.9603,
        introHook:
            "Commune de la Loire moyenne face à Orléans, Saint-Denis-en-Val allie zones inondables protégées, quartiers pavillonnaires et bourg ancien. Nos interventions rapides couvrent toute la commune y compris les hameaux (Le Bouchet, Melleray).",
        districts: ["Centre-bourg", "Le Bouchet", "Melleray", "Les Buissons", "Le Poutyl"],
        reviews: [
            { n: "Jérôme A.", q: "Saint-Denis-en-Val centre", t: "Serrure d'entrée remplacée avec conseil pertinent. Content." },
            { n: "Béatrice L.", q: "Saint-Denis Le Bouchet", t: "Dépannage rapide, moins de 20 minutes. Impressionnant." },
            { n: "Rémy S.", q: "Saint-Denis Melleray", t: "Porte blindée posée après cambriolage. Tranquillisant." },
        ],
        neighbors: ["orleans", "saint-jean-le-blanc", "saint-cyr-en-val", "sandillon"],
    },
    {
        slug: "saint-jean-le-blanc",
        name: "Saint-Jean-le-Blanc",
        postal: "45650",
        population: "9 000",
        distance: 3,
        lat: 47.8797,
        lon: 1.9231,
        introHook:
            "Voisine sud immédiate d'Orléans, Saint-Jean-le-Blanc est appréciée pour ses résidences familiales, ses zones vertes et son centre commercial. Notre artisan intervient en moins de 15 minutes dans toute la commune.",
        districts: ["Centre", "Le Petit Bois", "Les Genêts", "Les Sablons", "Le Champ Chardon"],
        reviews: [
            { n: "Solène M.", q: "Saint-Jean-le-Blanc centre", t: "Rapide, propre, tarif juste. Idéal en cas d'urgence." },
            { n: "Julien P.", q: "Saint-Jean-le-Blanc Les Genêts", t: "Serrure Fichet installée. Qualité au rendez-vous." },
            { n: "Hélène B.", q: "Saint-Jean-le-Blanc Les Sablons", t: "Porte claquée un dimanche à 8h du matin, intervention en 15 min." },
        ],
        neighbors: ["orleans", "saint-denis-en-val", "olivet", "saint-cyr-en-val"],
    },
    {
        slug: "jargeau",
        name: "Jargeau",
        postal: "45150",
        population: "4 500",
        distance: 20,
        lat: 47.8672,
        lon: 2.1236,
        introHook:
            "Petite cité ligérienne connue pour ses andouilles et son pont sur la Loire, Jargeau conserve un centre-bourg à taille humaine et des quartiers pavillonnaires en pleine expansion. Notre artisan intervient sur tout le canton.",
        districts: ["Centre", "Les Beauriches", "Le Bardon", "Sainte-Barbe"],
        reviews: [
            { n: "Denis C.", q: "Jargeau centre", t: "Porte ancienne ouverte sans dégât. Belle expertise." },
            { n: "Fabienne T.", q: "Jargeau Le Bardon", t: "Cylindre changé, tarif clair et pose rapide." },
            { n: "Louis D.", q: "Jargeau centre", t: "Devis honnête, aucune surprise. Recommande." },
        ],
        neighbors: ["chateauneuf-sur-loire", "sandillon", "darvoy", "sully-la-chapelle"],
    },
];

// --- Display name dictionary (slug → joli nom français avec accents et minuscules correctes) ---
// Couvre les villes principales (avec page) + les communes voisines (sans page) pour l'affichage.
const CITY_DISPLAY_NAMES = {
    // Villes principales
    "orleans": "Orléans",
    "olivet": "Olivet",
    "fleury-les-aubrais": "Fleury-les-Aubrais",
    "saran": "Saran",
    "saint-jean-de-braye": "Saint-Jean-de-Braye",
    "saint-jean-de-la-ruelle": "Saint-Jean-de-la-Ruelle",
    "montargis": "Montargis",
    "pithiviers": "Pithiviers",
    "gien": "Gien",
    "chateauneuf-sur-loire": "Châteauneuf-sur-Loire",
    "beaugency": "Beaugency",
    // Communes voisines (sans page dédiée)
    "saint-pryve-saint-mesmin": "Saint-Pryvé-Saint-Mesmin",
    "saint-cyr-en-val": "Saint-Cyr-en-Val",
    "chevilly": "Chevilly",
    "ormes": "Ormes",
    "ingre": "Ingré",
    "checy": "Chécy",
    "combleux": "Combleux",
    "la-chapelle-saint-mesmin": "La Chapelle-Saint-Mesmin",
    "amilly": "Amilly",
    "chalette-sur-loing": "Châlette-sur-Loing",
    "villemandeur": "Villemandeur",
    "courtenay": "Courtenay",
    "malesherbes": "Malesherbes",
    "outarville": "Outarville",
    "dadonville": "Dadonville",
    "puiseaux": "Puiseaux",
    "briare": "Briare",
    "chatillon-sur-loire": "Châtillon-sur-Loire",
    "poilly-lez-gien": "Poilly-lez-Gien",
    "sully-sur-loire": "Sully-sur-Loire",
    "jargeau": "Jargeau",
    "saint-denis-de-lhotel": "Saint-Denis-de-l'Hôtel",
    "germigny-des-pres": "Germigny-des-Prés",
    "meung-sur-loire": "Meung-sur-Loire",
    "tavers": "Tavers",
    "lailly-en-val": "Lailly-en-Val",
    "cravant": "Cravant",
    "la-ferte-saint-aubin": "La Ferté-Saint-Aubin",
    "saint-denis-en-val": "Saint-Denis-en-Val",
    "saint-jean-le-blanc": "Saint-Jean-le-Blanc",
    "saint-maurice-sur-fessard": "Saint-Maurice-sur-Fessard",
    "corquilleroy": "Corquilleroy",
    "saint-ay": "Saint-Ay",
    "mardie": "Mardié",
    "menestreau-en-villette": "Ménestréau-en-Villette",
    "marcilly-en-villette": "Marcilly-en-Villette",
    "saint-benoit-sur-loire": "Saint-Benoît-sur-Loire",
    "dampierre-en-burly": "Dampierre-en-Burly",
    "clery-saint-andre": "Cléry-Saint-André",
    "baccon": "Baccon",
    "ousson-sur-loire": "Ousson-sur-Loire",
    "bonny-sur-loire": "Bonny-sur-Loire",
    "ouzouer-sur-trezee": "Ouzouer-sur-Trézée",
    "beaulieu-sur-loire": "Beaulieu-sur-Loire",
    "sandillon": "Sandillon",
    "darvoy": "Darvoy",
    "sully-la-chapelle": "Sully-la-Chapelle",
    "cercottes": "Cercottes",
};

// --- Lookup helpers ---
export const getCityBySlug = (slug) => CITIES.find((c) => c.slug === slug) || null;
export const getCityName = (slug) => CITY_DISPLAY_NAMES[slug] || slug;

// Slugs des villes ayant une page dédiée (utile pour les liens internes — sinon affichage texte simple)
export const CITY_SLUGS_WITH_PAGE = new Set(CITIES.map((c) => c.slug).concat(["orleans"]));

export default CITIES;
